import { j as n } from "../../jsx-runtime.BREq8dyb.js";
import { styled as i, DialogActions as r, useThemeProps as m } from "@mui/joy";
import { memo as a } from "react";
const o = "DqSidePanelActions", p = i(r, {
  name: o,
  slot: "root"
})(), c = a((s) => {
  const {
    children: t,
    ...e
  } = m({
    name: o,
    props: s
  });
  return /* @__PURE__ */ n.jsx(p, { ...e, children: t });
});
c.displayName = "DqSidePanelActions";
export {
  c as default
};
//# sourceMappingURL=DqSidePanelActions.js.map
